module.exports = __webpack_public_path__ + "img/ic-blokk.e8e6c0fb.svg";